import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconSend } from '@tabler/icons-react';
import { TRPCClientError } from '@trpc/client';

import { trpc } from '../../../../../services/trpc';
import { SignatureRequestForm } from './-signature-request-form';

export function SignatureRequestButton({
  documentId,
  onSuccess = () => {},
  recipient,
  label,
  signatureRequestName,
}: {
  documentId: string;
  onSuccess?: () => void;
  recipient: string;
  label: string;
  signatureRequestName?: string;
}) {
  const sendSignatureRequest =
    trpc.documents.sendSignatureRequest.useMutation();

  const handleSendSignatureRequest = () => {
    modals.open({
      title: 'Confirmation',
      children: (
        <SignatureRequestForm
          recipient={recipient}
          defaultName={signatureRequestName}
          onSubmit={async values => {
            try {
              await sendSignatureRequest.mutateAsync({
                documentId,
                signatureRequestName: values.name,
                customText: values.customText,
              });
              modals.closeAll();
              notifications.show({
                title: 'Demande de signature envoyée',
                message: 'La demande de signature a été envoyée avec succès',
                color: 'green',
              });
              onSuccess();
            } catch (e: unknown) {
              console.log('e', e);
              notifications.show({
                title: 'Erreur',
                message:
                  e instanceof TRPCClientError
                    ? e.message
                    : 'Erreur lors de la demande de signature',
                color: 'red',
              });
            }
          }}
        />
      ),
    });
  };

  return (
    <Button
      leftSection={<IconSend size={16} />}
      loading={sendSignatureRequest.isPending}
      onClick={handleSendSignatureRequest}
      disabled={sendSignatureRequest.isPending}
    >
      {label}
    </Button>
  );
}
